// Phase 2 §6: Extended useCapTableSummary with state_type filter
import { useEffect, useState } from 'react';
import * as CapLedgerService from '@/services/capLedgerService';

type StateTypeFilter = 'LEGAL' | string[];

export function useCapTableSummary(companyId?: string, stateTypeFilter?: StateTypeFilter) {
  const [summary, setSummary] = useState<CapLedgerService.CapTableSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalShares, setTotalShares] = useState(0);

  useEffect(() => {
    async function loadSummary() {
      try {
        setLoading(true);
        // Pass state_type filter to service layer
        const data = await CapLedgerService.getCapTableSummary(companyId, stateTypeFilter);

        setSummary(data);

        const total = data.reduce((sum, entry) => sum + (entry.total_shares || 0), 0);
        setTotalShares(total);
      } catch (err) {
        console.error('Error loading cap table summary:', err);
      } finally {
        setLoading(false);
      }
    }

    loadSummary();

    const subscription = CapLedgerService.subscribeToLedgerEvents(() => {
      loadSummary();
    }, companyId);

    return () => {
      if (subscription) {
        CapLedgerService.unsubscribeFromChannel(subscription);
      }
    };
  }, [companyId, stateTypeFilter]);

  return { summary, loading, totalShares };
}
